let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dTo8c")).then(() => parcelRequire('43lbE'));